// extracted by mini-css-extract-plugin
export default {"coefficients":"coefficients--OngM","base":"base--ZIfn","profile":"profile--5UhJ"};